import React from "react";
import Spinner from "react-bootstrap/Spinner";
import "./index.css";

interface LoaderProps {
  children?: React.ReactNode;
}

const Loader: React.FC<LoaderProps> = () => {
  return (
    <div className="table-spinner-contanier">
      <Spinner animation="border" />
    </div>
  );
};

export default Loader;

